import type { RowData } from "@tanstack/react-table";
import Checkbox from "components/checkbox";
import intl from "react-intl-universal";
import type { TableColumnDef } from "./types";

export const ROW_SELECTION_COLUMN_ID = "select";

export function createRowSelectionColumn<TData extends RowData>(): TableColumnDef<TData> {
  return {
    id: ROW_SELECTION_COLUMN_ID,
    header: ({ table }) => (
      <Checkbox
        type="checkbox"
        checked={table.getIsAllRowsSelected()}
        inputProps={{ "aria-label": intl.get("commons.table.selectionToolbar.selectAllRows") }}
        inputRef={(el: HTMLInputElement | null) => {
          if (el) el.indeterminate = !table.getIsAllRowsSelected() && table.getIsSomeRowsSelected();
        }}
        onChange={table.getToggleAllRowsSelectedHandler()}
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        type="checkbox"
        checked={row.getIsSelected()}
        disabled={!row.getCanSelect()}
        inputProps={{ "aria-label": intl.get("commons.table.selectionToolbar.selectRow") }}
        onChange={row.getToggleSelectedHandler()}
      />
    ),
    enableHiding: false,
    size: 54,
    minSize: 54,
    maxSize: 54,
  };
}
